// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sign-up-link {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  font-size: 14px;\n  color: #9198b2; }\n\n.sign-link {\n  margin-left: 5px; }\n\n.btn-log-in {\n  flex-shrink: 0;\n  transition: all 0.5s ease;\n  height: 50px; }\n  .btn-log-in:hover {\n    color: #d6d6d6;\n    background: #516086; }\n\n.input-for-sign-up {\n  margin-bottom: 5px; }\n", ""]);
// Exports
module.exports = exports;
